import Radio from '@material-ui/core/Radio';
import { FC, ReactNode } from 'react';
import styles from './RadioButton.module.scss';

type Props = {
  checked: boolean;
  onChange?: (event: { target: { checked: boolean; value: string } }) => void;
  label?: ReactNode;
  value?: string;
  style?: React.CSSProperties;
  readonly?: boolean,
};

const RadioButton: FC<Props> = ({ checked, onChange, label, value, style, readonly }) => {
  return (
    <div style={{ cursor: readonly ? 'not-allowed' : 'pointer', ...style }}>
      <label className={styles.radioBtnContainer}>
        <Radio
          edge="start"
          checked={checked}
          onChange={(value) => {
            if (!readonly && onChange) {
              onChange(value);
            }
          }}
          tabIndex={-1}
          disableRipple
          checkedIcon={<span className={`${styles.icon} ${styles.checkedIcon}`} />}
          icon={<span className={styles.icon} />}
          value={value}
          style={{ cursor: readonly ? 'not-allowed' : 'pointer' }}
        />
        {label && <span style={{ cursor: readonly ? 'not-allowed' : 'pointer' }}>{label}</span>}
      </label>
    </div>
  );
};

export default RadioButton;
